import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Check: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22.1218 1.49248C22.0756 1.54941 19.1141 5.27877 15.5406 9.77997C11.9671 14.2812 9.03543 17.9669 9.02583 17.9706C9.01623 17.9742 7.36882 16.3245 5.36491 14.3046C3.36101 12.2846 1.71475 10.632 1.70657 10.632C1.69839 10.632 1.37556 10.9482 0.989186 11.3348L0.286682 12.0376L4.73278 16.5188L9.17885 21L9.23088 20.946C9.2664 20.9091 21.7078 5.2451 23.7639 2.64852C23.7789 2.62963 23.5491 2.43288 23.0261 2.01672C22.6083 1.68432 22.2528 1.40712 22.2361 1.40068C22.2193 1.39425 22.1679 1.43558 22.1218 1.49248Z'
        fill={fill}
      />
    </svg>
  )
}

export default Check
